// useAnnouncement.js
import { useState, useEffect } from 'react';
import api from '../helper/api';

const useAnnouncement = (API_URL) => {
  const [announcementText, setAnnouncementText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      setIsLoading(true);
      try {
        const data = await api.get('/content/items/constant?filter={Name:"Announcement"}');
        setAnnouncementText(data[0].Text_Value);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    }
    fetchAnnouncement();
  }, [API_URL]);

  return { announcementText, isLoading, error };
}

export default useAnnouncement;
